// tslint:disable: completed-docs

/**
 * Stores for the APP
 */
export const SAILS_APP_NAME = 'ROAMING_ADVISOR_APP';
